import wixLocation from 'wix-location';


$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

export function sendButton_click(event) {
	
	wixLocation.to("https://api.whatsapp.com/send?phone=972504673493&text=%D7%97%D7%99%D7%96%D7%A8%D7%95%20%D7%90%D7%9C%D7%99%20%D7%91%D7%91%D7%A7%D7%A9%D7%94%20%D7%9C%D7%92%D7%91%D7%99%20%D7%A2%D7%99%D7%A1%D7%95%D7%99%D7%99%D7%9D%20%D7%95%D7%97%D7%91%D7%99%D7%9C%D7%95%D7%AA%20%D7%A1%D7%A4%D7%90");
}